import React from "react";
import SectorLayout from "@/components/SectorLayout";
import data from "@/data/sectors/industrie";
export default function SecteurIndustrie() { return <SectorLayout data={data} />; }
